const GeneralError = ({ message }) => {
  return <div className="alert alert-danger mt-4 mb-3">{message}</div>;
};

export default GeneralError;
